export default __webpack_public_path__ + "static/media/login-bg.95cc2234.jpg";